<button class="primary-btn clear-button" type="reset">
    <img src="assets/icons/Trash.svg" alt="icon" />Clear Filters
</button>
<button class="primary-btn" type="submit">Apply Filters</button>
